/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ConditionType = {
    EMPLOYEE: 'EMPLOYEE',
    CLIENT: 'CLIENT',
    EVENT: 'EVENT',
    BIRTHDATE: 'BIRTHDATE',
    TOTAL: 'TOTAL',
    FIRST_ORDER: 'FIRST_ORDER',
    ACTIVATION_TIME: 'ACTIVATION_TIME',
    POLYGON: 'POLYGON',
    PRODUCT: 'PRODUCT',
    PRODUCT_COUNT: 'PRODUCT_COUNT',
    SYSTEM: 'SYSTEM',
    DELIVERY_TYPE: 'DELIVERY_TYPE',
    PRICE_AMOUNT: 'PRICE_AMOUNT',
    ACCUMULATOR: 'ACCUMULATOR',
    COMBO: 'COMBO'
} as const;
export type ConditionType = typeof ConditionType[keyof typeof ConditionType];

